import { render } from "./PayLaterSuccess.vue?vue&type=template&id=5a4d3b0a&scoped=true&ts=true"
import script from "./PayLaterSuccess.vue?vue&type=script&lang=ts"
export * from "./PayLaterSuccess.vue?vue&type=script&lang=ts"

import "./PayLaterSuccess.vue?vue&type=style&index=0&id=5a4d3b0a&lang=scss&scoped=true"

import exportComponent from "/home/production/domains/monteur.waterluxe.nl/monteur-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a4d3b0a"]])

export default __exports__